import { throwError as observableThrowError, Observable, Subject, throwError, BehaviorSubject } from 'rxjs'

import { tap, catchError, switchMap, filter, take } from 'rxjs/operators'
import { Inject, Injectable, Injector } from '@angular/core'
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { UserSettingsService } from './user-settings.service'

import { MsalService } from "@azure/msal-angular";
import { APP_CONFIG, AppConfiguration } from '../configs/app-configuration';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(
      private userSettingsService: UserSettingsService,
        private injector: Injector,
      @Inject(APP_CONFIG) private appConfiguration: AppConfiguration,
      ) {}

        private refreshTokenInProgress = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
        null
    );

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return next.handle(request).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    return this.handle401Error(request, next);
                  }
                return throwError(error);

            })
        )
    }

  getHotelingToken(): Observable<any> {
    const msalService = this.injector.get(MsalService);
    let hotelingClientIDScope =
      this.userSettingsService.appSettings.HotelingCloudClientId + this.userSettingsService.appSettings.ConciergeScope;

    const hotelingCloudApiReq = {
      scopes: [hotelingClientIDScope]
    };
    return msalService.acquireTokenSilent(hotelingCloudApiReq);
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.refreshTokenInProgress) {
      this.refreshTokenInProgress = true;
      this.refreshTokenSubject.next(null);

      return this.getHotelingToken().pipe(
        switchMap((res: any) => {
          this.refreshTokenInProgress = false;
          this.refreshTokenSubject.next(res.accessToken);
          return next.handle(this.addAuthenticationToken(request, res.accessToken));
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addAuthenticationToken(request,jwt));
        })
      );
    }
  }

  addAuthenticationToken(request: HttpRequest<any>, token: string) {
    window["hotelingDataToken"] = token;
    return request.clone({
        setHeaders: {
          Authorization: `${this.appConfiguration.tokenPrefix} ${token}`,
        },
      });
    };
}
